// File: src/components/Header.jsx

import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";

import LanguageIcon from "@mui/icons-material/Language";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n, t } = useTranslation();

  const [anchorElLang, setAnchorElLang] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <AppBar position="sticky" color="primary" elevation={2}>
      <Toolbar sx={{ display: "flex", gap: 1 }}>
        
        {/* 🔙 زر الرجوع */}
        <IconButton
          color="inherit"
          onClick={() => navigate(-1)}
          disabled={location.pathname === "/dashboard"} 
        >
          <ArrowBackIcon />
        </IconButton>

        {/* 🏠 زر الرئيسية */}
        <IconButton color="inherit" onClick={() => navigate("/dashboard")}>
          <HomeIcon />
        </IconButton>

        {/* عنوان الصفحة */}
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: "bold" }}>
          {t("common.dashboard")}
        </Typography>

        {/* 🌐 زر اللغة */}
        <Tooltip title={t("common.language")}>
          <IconButton color="inherit" onClick={(e) => setAnchorElLang(e.currentTarget)}>
            <LanguageIcon />
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorElLang}
          open={Boolean(anchorElLang)}
          onClose={() => setAnchorElLang(null)}
        >
          <MenuItem onClick={() => { i18n.changeLanguage("ar"); setAnchorElLang(null); }}>
            {t("common.arabic")}
          </MenuItem>
          <MenuItem onClick={() => { i18n.changeLanguage("en"); setAnchorElLang(null); }}>
            {t("common.english")}
          </MenuItem>
        </Menu>

        {/* ⚙️ زر الحساب */}
        <Tooltip title={t("common.settings")}>
          <IconButton color="inherit" onClick={(e) => setAnchorElUser(e.currentTarget)}>
            <AccountCircleIcon />
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorElUser}
          open={Boolean(anchorElUser)}
          onClose={() => setAnchorElUser(null)}
        >
          <MenuItem onClick={() => { navigate('/company/profile'); setAnchorElUser(null); }}>
            بيانات الشركة
          </MenuItem>
          
          <MenuItem onClick={handleLogout}>{t("common.logout")}</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
